import { Injectable } from '@angular/core';
import {DateRangeModel} from '../../../../models/date-range.model';
import {Appointment, IAppointment} from '../../../../landing/models';
import {LandingPageService} from '../../../../services/landing-page.service';
import moment from 'moment';
import {Subject} from 'rxjs';
import {Globals} from '../../../../globals';
import {FlagsService} from '../../../../services/flags.service';
import { FileManagerService } from 'src/app/modules/file-manager/file-manager.service';
import { AppointmentFlagDataModel } from 'src/app/models/appointments/appointment-flag-data.model';

@Injectable({
  providedIn: 'root'
})
export class HomeAccordionService {
  numScheduleItems = 0;

  scheduleDate: moment.Moment;
  today: moment.Moment = moment();

  scheduleDateHover: boolean = false;
  recentPatientRangeHover: boolean = false;
  currAndFutureAppointments: Appointment[] = [];

  selectedAppointmentId: string;
  recentPatientRange: string = '';
  pastAppointments: Appointment[] = [];

  apptPageSize: number = 10;
  apptPageIndex: number = 0;

  changeDateEvent: Subject<Appointment[]> = new Subject<Appointment[]>();
  changePatientRangeEvent: Subject<Appointment[]> = new Subject<Appointment[]>();

  constructor(
    private fileService: FileManagerService,
    private landingPageService: LandingPageService, 
    private globals: Globals, 
    private flagsService: FlagsService) { }

  /*changeScheduleDate(isIncrementing: boolean) {
    this.changeDateEvent.next(isIncrementing);
  }*/

  loadScheduleAppointments(): void {
    const today: Date = new Date();
    const future: Date = new Date();
    // future.setDate(today.getDate() + 7);
    const tdoDateRange = new DateRangeModel(today, today);
    const localTodayDate = new DateRangeModel(today, today);
    this.scheduleDate = moment();

    this.landingPageService.getAppointmentsForDoctorByDateRange('DocID', tdoDateRange.toString(), localTodayDate.toString())
      .subscribe(
        (data: Appointment[]) => {
          this.currAndFutureAppointments = data.map(o => new Appointment(o));
          this.currAndFutureAppointments.forEach(appt => {
            if (appt.isFirstVisit) {
              // console.log('appt is first visit', appt.AppointmentId);
              const firstVisitFlag = new AppointmentFlagDataModel();
              firstVisitFlag.AppointmentFlagID = '';
              firstVisitFlag.AppointmentId = appt.AppointmentId;
              firstVisitFlag.enumAppoitmentFlagID = '00000109-1000-0000-0000-000000000017';
              appt.dataAppointmentFlags.push(firstVisitFlag);
            }
          });
          this.selectedAppointmentId = this.globals.currentAppointmentId;

          for (const appt of this.currAndFutureAppointments) {
            appt.PatientImageUrl = appt.PatientImageUrl? this.fileService.getDocumentImageUrl(appt.PatientId,appt.PatientImageUrl) : '/assets/Images/defaultPatient.PNG';

            this.flagsService.getPatientFlags(this.globals.LOCID, appt.PatientId).subscribe((res) => {
              appt.dataPatientFlags = res;
            });
          }

          this.changeDateEvent.next(this.currAndFutureAppointments);
          const count = this.currAndFutureAppointments.length;
          setTimeout(() => { this.numScheduleItems = count; }, 0);
        },
        err => {
          console.log(err);
        }
      );
  }

  async changeScheduleDate(isIncrementing: boolean): Promise<void> {
    if (isIncrementing === null || isIncrementing === undefined) {
      return;
    }

    if (isIncrementing) {
      this.scheduleDate = this.scheduleDate.add(1, 'days');
    }
    else if (!isIncrementing && !this.scheduleDate.isSameOrBefore(moment(), 'date')) {
      this.scheduleDate = this.scheduleDate.add(-1, 'days');
    }

    const tdoDateRange = new DateRangeModel(this.scheduleDate.toDate(), this.scheduleDate.toDate());
    const localTodayDate = new DateRangeModel(this.today.toDate(), this.today.toDate());

    try {
      const results = await this.landingPageService.getAppointmentsForDoctorByDateRange('DocID', tdoDateRange.toString(), localTodayDate.toString()).toPromise();

      this.currAndFutureAppointments = results.map(o => new Appointment(o));
      this.currAndFutureAppointments.forEach(appt => {
        if (appt.isFirstVisit) {
          // console.log('appt is first visit', appt.AppointmentId);
          const firstVisitFlag = new AppointmentFlagDataModel();
          firstVisitFlag.AppointmentFlagID = '';
          firstVisitFlag.AppointmentId = appt.AppointmentId;
          firstVisitFlag.enumAppoitmentFlagID = '00000109-1000-0000-0000-000000000017';
          appt.dataAppointmentFlags.push(firstVisitFlag);
        }
      });
      const count = this.currAndFutureAppointments.length;
      setTimeout(() => { this.numScheduleItems = count; }, 0);
      this.selectedAppointmentId = this.globals.currentAppointmentId;
      for (const appt of this.currAndFutureAppointments) {
        appt.PatientImageUrl = appt.PatientImageUrl? this.fileService.getDocumentImageUrl(appt.PatientId,appt.PatientImageUrl) : '/assets/Images/defaultPatient.PNG';

        this.flagsService.getPatientFlags(this.globals.LOCID, appt.PatientId).subscribe((res) => {
          appt.dataPatientFlags = res;
        });
      }
      this.changeDateEvent.next(this.currAndFutureAppointments);
    } catch (e) {
      console.log(e);
    }
  }

  // loadPastAppointments(): void {
  //   this.landingPageService.getAppointmentsForDoctorByPaging('DocID', this.apptPageSize, this.apptPageIndex)
  //     .subscribe(
  //       (data: IAppointment[]) => {
  //         this.pastAppointments = this.filterForPastAppointments(data);
  //         this.recentPatientRange = this.generateRecentPatientRange();
  //         this.changePatientRangeEvent.next(this.pastAppointments);
  //       },
  //       err => {
  //         console.log(err);
  //       }
  //     );
  // }

  // async changeRecentPatients(isIncrementing: boolean): Promise<void> {
  //   if (isIncrementing === null || isIncrementing === undefined) {
  //     return;
  //   }

  //   if (isIncrementing) {
  //     this.apptPageIndex++;
  //   }
  //   else if (!isIncrementing) {
  //     this.apptPageIndex--;
  //   }

  //   this.recentPatientRange = this.generateRecentPatientRange();

  //   try {
  //     const results = await this.landingPageService.getAppointmentsForDoctorByPaging('DocID', this.apptPageSize, this.apptPageIndex)
  //       .toPromise();

  //     this.pastAppointments = this.filterForPastAppointments(results);
  //     this.changePatientRangeEvent.next(this.pastAppointments);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  private filterForPastAppointments(data: IAppointment[]) {
    const filteredData = data.filter(o => new Date(o.StartDateTime) < new Date(Date.now()));
    return filteredData.map(o => new Appointment(o));
  }

  private generateRecentPatientRange(): string {
    const start: number = (this.apptPageIndex * this.apptPageSize) + 1;
    const end: number = this.apptPageSize * (this.apptPageIndex + 1);

    return `${start}-${end}`;
  }
}
